import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=7c0b8602&scoped=true"
import script from "./RegisterForm.js?vue&type=script&lang=js&external"
export * from "./RegisterForm.js?vue&type=script&lang=js&external"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=7c0b8602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0b8602",
  null
  
)

export default component.exports